import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ProdutosPermitidosService} from './produtos-permitidos.service';
import {MensagemService} from '../mensagem.service';
import {BnLoadingService} from '@bndes/bndes-ux4/bndes-angular-utils';
import {ModalidadeOperacionalRepasse} from 'src/app/model/modalidade-operacional-repasse.model';
import {ModalidadeOperacionalRepasseDTO} from 'src/app/model/modalidade-operacional-repasse-dto.model';

@Component({
  selector: 'app-modal-produtos-permitidos',
  templateUrl: './modal-produtos-permitidos.component.html',
  styleUrls: ['./modal-produtos-permitidos.component.scss'],
  standalone: false
})

export class ModalProdutosPermitidosComponent implements OnInit {
  public formulario: FormGroup;
  public mensagemAviso: string = "";
  public produtosPermitidos: ModalidadeOperacionalRepasse[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private produtosPermitidosService: ProdutosPermitidosService,
    private mensagemService: MensagemService,
    private loadingService: BnLoadingService,
  ) {
    this.formulario = this.formBuilder.group({
      codigoProduto: [null, [Validators.required, Validators.pattern(/^[0-9]+$/)]],
    });
  }

  ngOnInit(): void {

  }

  buscar(){
    this.produtosPermitidosService.listarTodosFiltrados(this.obterFiltrosBusca()).subscribe(res => {
      this.produtosPermitidos = res;
    });
  }

  obterFiltrosBusca() {
    let dadosPreenchidos: any = {};
    const form = this.formulario.value;

    if (form.codigoProduto) {
      dadosPreenchidos.idProduto = form.codigoProduto;
    }

    return dadosPreenchidos;
  }

  salvar() {

    const dados = this.formulario.value;


    const dto: ModalidadeOperacionalRepasseDTO = {
      id: dados.codigoProduto
    }

    this.loadingService.bloqueiaTela();
    this.produtosPermitidosService.salvarProdutoModalidadeOperacional(dto).subscribe({
      next: () => {
        this.loadingService.liberaTela();
        this.fecharAposSalvar(dto.id);
        this.mensagemService.adicionarMensagemSucesso('Código de produto cadastrado com sucesso');

      },
      error: () => {
        this.loadingService.liberaTela();
        this.mensagemService.adicionarMensagemErro('Erro ao salvar codigo de Produto');
      }
    })
  }


  fechar() {
    this.activeModal.close({ botao: 'fechar', valor: null });
  }

  fecharAposSalvar(dados: any) {
    this.activeModal.close({ botao: 'salvar', valor: dados });
  }

}
